module.exports = __webpack_public_path__ + "img/250.5117f978.jpg";